import type { VocabularyResponse, VocabularyTerm, VocabularyTermBody } from "@hermes/shared";
import { api } from "./http";

/** `company` — общий словарь компании: правит только администратор. */
export type VocabularyScope = "personal" | "company";

const base = (scope: VocabularyScope) => (scope === "company" ? "/api/admin/vocabulary" : "/api/vocabulary");

export const vocabularyApi = {
  get: () => api<VocabularyResponse>("/api/vocabulary"),
  add: (scope: VocabularyScope, body: VocabularyTermBody) => api<{ term: VocabularyTerm }>(base(scope), { method: "POST", json: body }),
  remove: (scope: VocabularyScope, id: string) => api<void>(`${base(scope)}/${id}`, { method: "DELETE" }),
};
